<div class="page">
  <kgrid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [label]="label"
    [areaName]="areaName"
    [name]="apiName"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [unSortableFilterable]="unSortableFilterable"
    [isModal]="false"
    [isEdit]="false"
    [isVisible]="true"
    [actionTregger]="onActionClick"
    (onRowSelected)="onRowSelected($event)"
    [actions]="actions"
    [filters]="filters"
    [hasBracketForNegativeValues]="false">
  </kgrid>
</div>
